import { createBrowserRouter } from 'react-router-dom'
import { AppShell } from './AppShell'
import { RequireAuth } from '../auth/RequireAuth'
import { HomePage } from '../routes/HomePage'
import { ProjectDetailPage } from '../routes/ProjectDetailPage'
import { ExplorePage } from '../routes/ExplorePage'
import { SourcesPage } from '../routes/SourcesPage'
import { NoticesPage } from '../routes/NoticesPage'
import { LoginPage } from '../routes/LoginPage'
import { AuthCallback } from '../routes/AuthCallback'

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/auth/callback', element: <AuthCallback /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <HomePage /> },
      { path: 'projects/:id', element: <ProjectDetailPage /> },
      { path: 'explore', element: <ExplorePage /> },
      { path: 'sources', element: <SourcesPage /> },
      { path: 'notices', element: <NoticesPage /> },
    ],
  },
])
